require("babel-polyfill");
// Object-fit polyfill
const objectFitImages = require('object-fit-images'),
			flickity 				= require('flickity-as-nav-for');

const nav = require("./modules/navigation.js");

objectFitImages();

const burger = document.querySelector( '.nav-trigger' );
burger.addEventListener( 'click', (e) => nav.toggleResponsiveMenu() );

const vids = [...document.querySelectorAll('.video_block')];

vids.forEach( (v) => {
	const vid = v.querySelector('video'),
				play = v.querySelector('.playvid');
	if (!vid || !play) return;
	play.addEventListener('click', () => {
		v.classList.add('playing');
		vid.play();
	});
	vid.addEventListener('click', () => {
		v.classList.remove('playing');
		vid.pause();
	})
});

/* ============================== 
	 Scroll to anchor nav
	 ============================== */ 

const anchorNav = [...jQuery('.menu-item')];

anchorNav.forEach( (n) => {
	if (!jQuery(n).hasClass('.bottom-link')) {
		const link 					= jQuery(n).children('a'),
					href 					= link.attr('href'),
					scroll_offset = jQuery('.top-bar').height();
		link.click( function(e) {
			e.preventDefault();
			jQuery('html, body').stop().animate({
				scrollTop: jQuery(href).offset().top - scroll_offset
			}, 1500);
		});
	}
});

/* ============================== 
	 Scroll to form (buttons)
	 ============================== */ 

const buttons = [...jQuery('.button').not('.gform_button')];

buttons.forEach( (b) => {
	jQuery(b).click( function(e) {
		const scroll_offset = jQuery('.top-bar').height();
		e.preventDefault();
		jQuery('html, body').stop().animate({
			scrollTop: jQuery('#signup').offset().top - scroll_offset
		}, 1500);
	})
});

jQuery('.main-logo').click( function(e) {
	e.preventDefault();
	jQuery('html, body').stop().animate({ scrollTop: 0 });
})

/* ============================== 
	 Flickity Sliders
	 ============================== */ 

// Parthers Slider

const pslider = document.querySelector('.parthers-slider');

if (pslider) {
	const partners_slider = new flickity( pslider, {
		cellAlign: 'left',
		contain: true,
		prevNextButtons: true,
		adaptiveHeight: false,
		setGallerySize: false,
		pageDots: 			false,
		wrapAround: 		true,
		arrowShape: { 
		  x0: 10,
		  x1: 60, y1: 50,
		  x2: 65, y2: 45,
		  x3: 20
		},
		cellSelector: '.slide'
	});

	// Re-init broken carousels
	jQuery(window).load(function(){
		partners_slider.resize();
	});
}

// Main Linked Sliders

const hero_img = document.querySelector('.image-slider');
const hero_text = document.querySelector('.text-slider');

if (hero_img) {

	// Text slider
	const herotxt = new flickity( hero_text, {
		cellAlign: 'left',
		contain: true,
		prevNextButtons:	false,
		adaptiveHeight: 	false,
		setGallerySize: 	false,
		pageDots: 				false,
		wrapAround: 			true,
		cellSelector: 		'.slide',
		asNavFor: 				hero_img
	});

	// Image slider
	const heroimg = new flickity( hero_img, {
		cellAlign: 'left',
		contain: true,
		prevNextButtons:false,
		adaptiveHeight: false,
		setGallerySize: true,
		wrapAround: 		true,
		autoPlay: 			true,
		cellSelector: '.slide'
	});
}

